import { render } from "./add-company-btn.vue?vue&type=template&id=413e9be8"
import script from "./add-company-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./add-company-btn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/shipping-companies/components/add-company-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "413e9be8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('413e9be8', __exports__)) {
    console.log('reload')
    api.reload('413e9be8', __exports__)
  }
  
  module.hot.accept("./add-company-btn.vue?vue&type=template&id=413e9be8", () => {
    console.log('re-render')
    api.rerender('413e9be8', render)
  })

}


export default __exports__